
import { hex } from '@/services/custom'

export const createAffiliate = (user) => {
  // Default values
  let name = '';
  let authUid = '';
  let contactEmail = '';
  let accessCode = '';
  let code = '';
  let masterCode = '';
  let password = undefined;
  let color = hex();
  let dataUrl = '';
  let isDeactivated = false;

  let fixedCommission = 0;
  let feeCommission = 0;
  let affiliationModel = 'SEMIFIXED';
  let serviceFeeMode = 'ABSOLUTE';
  let serviceFee = 0;
  let partnerType = 'B2C';
  let partnerCategory = 'Other';
  let cancellationsEnabled = true;
  let modificationsEnabled = true;
  let openTicketsEnabled = true;
  let hasAccessToBookings = false;
  let widgetApiKeyId = null;
  let widgetApiKeyValue = null;

  // Initialize default email settings
  let emailSettings = {
    partnerEmail: '',
    receiverSettings: {
      bookingConfirmation: 'NO_ONE',
      bulkModification: 'NO_ONE',
      modificationRequest: 'NO_ONE',
      bookingError: 'NO_ONE',
      bookingRefund: 'NO_ONE',
      bookingPartialRefund: 'NO_ONE',
      tripCancellation: 'NO_ONE',
      bookingCurrentState: 'NO_ONE',
      cancellationReport: 'NO_ONE',
      bulkActionReport: 'NO_ONE',
    }
  };

  if (user) {
    const {
      authUid: uAuthUid,
      code: uCode,
      name: uName,
      contactEmail: uContactEmail,
      color: uColor,
      dataUrl: uDataUrl,
      password: uPassword,
      masterCode: masterCodesArray,
      isDeactivated: uIsDeactivated,
      emailSettings: uEmailSettings = emailSettings,
      partnerType: uPartnerType,
      partnerCategory: uPartnerCategory,
      cancellationsEnabled: uCancellationsEnabled,
      modificationsEnabled: uModificationsEnabled,
      openTicketsEnabled: uOpenTicketsEnabled,
      hasAccessToBookings: uHasAccessToBookings,
      widgetApiKeyId: uWidgetApiKeyId,
      widgetApiKeyValue: uWidgetApiKeyValue,
    } = user;

    authUid = uAuthUid;
    name = uName;
    color = uColor;
    code = uCode;
    contactEmail = uContactEmail;
    password = uPassword;
    isDeactivated = uIsDeactivated || false;
    masterCode = masterCodesArray?.toString?.() || '';
    dataUrl = uDataUrl;
    partnerType = uPartnerType;
    cancellationsEnabled = uCancellationsEnabled;
    modificationsEnabled = uModificationsEnabled;
    openTicketsEnabled = uOpenTicketsEnabled;
    hasAccessToBookings = uHasAccessToBookings;
    widgetApiKeyId = uWidgetApiKeyId;
    widgetApiKeyValue = uWidgetApiKeyValue;

    if (uPartnerCategory) {
      partnerCategory = uPartnerCategory;
    }

    if (uEmailSettings) {
      emailSettings = uEmailSettings;
    }
  }

  if (user && user.scheme) {
    const {
      feeCommission: sFeeCommission,
      fixedCommission: sFixedCommission,
      affiliationModel: sAffiliationModel,
      serviceFeeValue,
      serviceFeeMode: sServiceFeeMode,
    } = user.scheme;

    fixedCommission = sFixedCommission;
    feeCommission = sFeeCommission;
    affiliationModel = sAffiliationModel;
    serviceFeeMode = sServiceFeeMode;
    serviceFee = sServiceFeeMode === 'ABSOLUTE' ? (serviceFeeValue / 100) : serviceFeeValue;
  }

  return {
    name,
    authUid,
    contactEmail,
    accessCode,
    code,
    masterCode,
    password,
    color,
    dataUrl,
    isDeactivated,
    fixedCommission,
    feeCommission,
    affiliationModel,
    serviceFeeMode,
    serviceFee,
    emailSettings,
    partnerType,
    partnerCategory,
    cancellationsEnabled,
    modificationsEnabled,
    openTicketsEnabled,
    hasAccessToBookings,
    widgetApiKeyId,
    widgetApiKeyValue,
  };
}